import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        groupId: String
    };
    static targets = ["status"];

    connect() {
        // Controller connected
    }

    async refresh(event) {
        event.preventDefault();

        const button = event.currentTarget;
        const originalText = button.innerHTML;

        button.disabled = true;
        button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Kraunama...';

        try {
            const response = await fetch('/wp-json/api/dashboard/for-leaders/refresh-queue', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    group_id: this.groupIdValue,
                }),
            });

            if (!response.ok) throw new Error(response.status);

            const data = await response.json();

            if (this.hasStatusTarget) {
                this.statusTarget.classList.remove('text-danger');
                if (data.count === 0) {
                    this.statusTarget.innerText = 'Sąrašas atnaujintas. Laukiančiųjų eilėje nėra.';
                } else {
                    this.statusTarget.innerText = `Rezerve laukiančiųjų - ${data.count}`;
                }
            }

            // Wait a moment so user sees the updated status
            await new Promise(r => setTimeout(r, 1500));

            // Reload page to show updated data from cache
            window.location.reload();

        } catch (error) {
            console.error('Error refreshing queue:', error);
            if (this.hasStatusTarget) {
                this.statusTarget.innerText = 'Klaida: nepavyko atnaujinti sąrašo.';
                this.statusTarget.classList.add('text-danger');
            }
            button.disabled = false;
            button.innerHTML = originalText;
        }
    }
}
